import DASHBOARD from './dashboard';
import NHS_PATIENT_DASHBOARD from './nhs_patient_dashboard';
import AD_PATIENT_DASHBOARD from './ad_patient_dashboard';
import NY_PATIENT_DASHBOARD from './ny_patient_dashboard';
import NAVIGATION from './navigation';
import NAVIGATION_WEIGHT_UNITS from './navigation_weight_units';
import NAVIGATION_MAIN_NHS from './navigation_main_nhs';
import CHAT from './chat';
import WEIGHTDETAILS from './weight_details';
import FOODDETAILS from './food_details';
import MOODDETAILS from './mood_details';
import EXERCISEDETAILS from './exercise_details';
import DAILYREPORTDETAILS from './daily_report_details';
import SMARTGOALSWEIGHT from './smart_goals_weigh';
import FOODQUESTIONNAIRE from './food_questionnaire';
import COMMUNITY from './community_details';
import ACTIVITY_SUMMARY from './activity_summary';
import NHS_PRACTITIONER_TICKET from './nhs_practitioner_ticket';
import TICKET from './ticket';
import FOODLOGS from './food_logs';
import MOODLOGS from './mood_logs';
import EXERCISELOGS from './exercise_logs';
import FILESTAGS from './file_tags';
import LIBRARYFILES from './library_files';
import MY_FILES_DASHBOARD from './my_files';
import EVENT_CANCEL from './event_cancel';
import ANALYTIC_TICKETS_LOGS from './analytic_tickets_logs';
import ANALYTIC_TICKET_LOGS from './analytic_ticket_logs';
import INVITE from './invite';
import INVITE_SINGLE_FORM from './invite_single_form';
import INVITE_FUNC_FORM from './invite_func_form';
import PRECALL_MEETING from './precall_meeting';
import SURVEY from './survey';
import STATISTIC from './statistic';
import MU_NAVIGATION from './mu_navigation';
import FREETIME_FORM from './freetime_form';
import USER_FORM from './user_form';
import TICKET_REFERRAL from './ticket_referral';
import REFERRAL_EDIT from './referral_edit';
import OPTI_PRACTITIONER_DASHBOARD from './opti_practitioner_dashboard';
import FORM_INVITE from './form_invite';
import ADMIN_CLIENT_MANAGEMENT from './admin_client_management';
import ADMIN_CLIENT_MANAGEMENT_WITH_INVITATIONS from './admin_client_management_with_invitations';
import ADMIN_ORG_MANAGEMENT from './admin_organization_management';
import ADMIN_OWN_ORG from './admin_own_organization';
import SURVEYS from './surveys';
import TICKET_REFERRAL_ANSWER from './ticket_referral_answer';
import SUPPORT from './support';
import REFERRAL_SEARCH_CLIENTS from './referral_search_clients';
import USER_TICKETS from './user_tickets';
import ACTIVITY_PARTICIPANTS_TICKETS_CLOSE from './activity_participants_tickets_close';
import KIND_SIDEBAR_LEFT from './sidebar_left';
import KIND_SIDEBAR_LEFT_PATIENT from './kind_sidebar_left_patient';
import KIND_CONTACTS from './kind_contacts';
import KIND_USER_NAVIGATION from './sidebar_left_user_navigation';
import ADMIN_SCHEDULERS from './admin_schedulers';
import ADMIN_SCHEDULER_FORM from './admin_scheduler_form';
import NAVBAR_DEFAULT from './navbar_default';
import NAVBAR_KIND from './navbar_kind';
import KIND_BOTTOM_SLIDER_NAVBAR_MENU from './kind_bottom_slider_navbar_menu';
import KIND_BOTTOM_SLIDER_ARTICLE_MENU from './kind_bottom_slider_article_menu';
import KIND_INVITE_FUNC_FORM from './kind_invite_func_form';
import LUKAS_INVITE_FUNC_FORM from './lukas_invite_func_form';
import BROADCAST_MESSAGE from './broadcast_message';
import BROADCAST_MESSAGE_INPUT from './broadcast_message_input';
import TICKET_CHAT from './ticket_chat';
import CHAT_USER_INFO from './kind_chat_user_info';
import CHAT_USER_NOTES from './kind_chat_user_notes';
import CHAT_USER_MANAGE_NOTES from './kind_chat_user_manage_notes';
import CHAT_USER_CARETEAM from './kind_chat_user_careteam';
import CHAT_TICKET_ACTIONS from './chat_ticket_actions';
import BROADCAST_MESSAGE_ACTIONS from './broadcast_message_actions';
import ASSIGN_SCHEDULER from './assign_scheduler';
import ARTICLES from './articles_overview';
import ARTICLES_TICKET from './articles_ticket';
import ARTICLES_MANAGE from './article_manage';
import ARTICLE_VIEW from './article_overview';
import GENERATE_TEMPLATE from './generate_template';
import ASSIGN_TICKET_SURVEY from './assign_ticket_survey';
import FILE_MANAGE from './file_manage';
import EVENT_FORM from './event_form';
import TICKET_VIDEO_CONFERENCE from './ticket_video_conference';
import TICKET_SURVEY from './ticket_survey';
import BOOKING_OVERVIEW from './booking_meeting';
import BOOKING_CALENDAR from './booking_calendar';
import SCHEDULER_CHAT_MESSAGE from './scheduler_chat_message';
import SCHEDULER_CHAT_MESSAGE_LIST from './scheduler_chat_message_list';
import TICKET_QUESTIONNAIRE from './ticket_questionnaire'; // Old questionnaire system widgets
import OPTI_SURVEY_PREVIEW from './opti_survey_preview';
import COMMUNITY_DETAILS_NYN from './community_details_nyn';
import ACTIVITIES_DETAILS_NYN from './activities_details_nyn';

// Inside my proptypes.js file
import PropTypes, { oneOfType, arrayOf, shape, number, string } from 'prop-types';

export const widget_structure = {
	content: string.isRequired,
	breakpoints: shape({
		xs: number,
		sm: number,
		md: number,
		xl: number,
	}).isRequired,
	lazy_loading: number /** miliseconds */,
};

export const catalogue_structure = {
	name: string.isRequired /** Options: name of catalogue */,
	sx: oneOfType([arrayOf(oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]) /** MUI sx prop */,
	spacing: number /** Theme spacing options */,
	rowSpacing: number /** Theme rowSpacing options */,
	columnSpacing: number /** Theme columnSpacing options */,
	direction: string /** Options: row, row-reverse, column, column-reverse */,
	justifyContent: string /** Options: flex-start, center, flex-end, space-between, space-around, space-evenly */,
	alignItems: string /** Options: flex-start, center, flex-end, stretch, baseline */,
	widgets: arrayOf(shape(widget_structure)).isRequired,
	onmount: oneOfType([PropTypes.func, PropTypes.bool]) /** Function to be called on mount of the catalogue, or false if not needed */,
};

export default {
	DASHBOARD,
	NAVIGATION,
	NAVIGATION_WEIGHT_UNITS,
	NAVIGATION_MAIN_NHS,
	CHAT,
	WEIGHTDETAILS,
	FOODDETAILS,
	MOODDETAILS,
	EXERCISEDETAILS,
	DAILYREPORTDETAILS,
	SMARTGOALSWEIGHT,
	FOODQUESTIONNAIRE,
	NHS_PATIENT_DASHBOARD,
	COMMUNITY,
	ACTIVITY_SUMMARY,
	TICKET,
	NHS_PRACTITIONER_TICKET,
	AD_PATIENT_DASHBOARD,
	NY_PATIENT_DASHBOARD,
	FOODLOGS,
	MOODLOGS,
	EXERCISELOGS,
	FILESTAGS,
	LIBRARYFILES,
	MY_FILES_DASHBOARD,
	PRECALL_MEETING,
	INVITE,
	INVITE_SINGLE_FORM,
	ANALYTIC_TICKETS_LOGS,
	ANALYTIC_TICKET_LOGS,
	SURVEY,
	EVENT_CANCEL,
	STATISTIC,
	MU_NAVIGATION,
	FREETIME_FORM,
	USER_FORM,
	TICKET_REFERRAL,
	REFERRAL_EDIT,
	OPTI_PRACTITIONER_DASHBOARD,
	FORM_INVITE,
	ADMIN_CLIENT_MANAGEMENT,
	ADMIN_CLIENT_MANAGEMENT_WITH_INVITATIONS,
	ADMIN_ORG_MANAGEMENT,
	SURVEYS,
	TICKET_REFERRAL_ANSWER,
	ADMIN_OWN_ORG,
	SUPPORT,
	REFERRAL_SEARCH_CLIENTS,
	USER_TICKETS,
	ACTIVITY_PARTICIPANTS_TICKETS_CLOSE,
	KIND_SIDEBAR_LEFT,
	KIND_SIDEBAR_LEFT_PATIENT,
	KIND_CONTACTS,
	KIND_USER_NAVIGATION,
	REFERRAL_SEARCH_CLIENTS,
	USER_TICKETS,
	ACTIVITY_PARTICIPANTS_TICKETS_CLOSE,
	ADMIN_SCHEDULERS,
	ADMIN_SCHEDULER_FORM,
	INVITE_FUNC_FORM,
	NAVBAR_DEFAULT,
	NAVBAR_KIND,
	KIND_BOTTOM_SLIDER_NAVBAR_MENU,
	KIND_INVITE_FUNC_FORM,
	LUKAS_INVITE_FUNC_FORM,
	BROADCAST_MESSAGE,
	BROADCAST_MESSAGE_INPUT,
	BROADCAST_MESSAGE_ACTIONS,
	TICKET_CHAT,
	CHAT_USER_INFO,
	CHAT_USER_CARETEAM,
	CHAT_USER_NOTES,
	CHAT_USER_MANAGE_NOTES,
	CHAT_TICKET_ACTIONS,
	ARTICLES,
	ARTICLES_TICKET,
	ARTICLES_MANAGE,
	ARTICLE_VIEW,
	KIND_BOTTOM_SLIDER_ARTICLE_MENU,
	ASSIGN_SCHEDULER,
	GENERATE_TEMPLATE,
	FILE_MANAGE,
	ASSIGN_TICKET_SURVEY,
	EVENT_FORM,
	TICKET_VIDEO_CONFERENCE,
	TICKET_SURVEY,
	BOOKING_OVERVIEW,
	BOOKING_CALENDAR,
	SCHEDULER_CHAT_MESSAGE,
	SCHEDULER_CHAT_MESSAGE_LIST,
	TICKET_QUESTIONNAIRE, // Old questionnaire system widgets
	OPTI_SURVEY_PREVIEW,
  COMMUNITY_DETAILS_NYN,
  ACTIVITIES_DETAILS_NYN,
};
